import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Form,
    Checkbox,
    Modal,
} from 'semantic-ui-react';

import supprimer from '../../../assets/svg/supprimer.svg';
import Exit from '../../../assets/svg/Exit.svg';

import { addArticle } from '../../../redux/actions/ListAction'

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app,
    list: state.list
})

const mapActionToProps = {
    addArticle: addArticle
}

class ConnectedDeleteListArticle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fkuidarticle: this.props.fkuidarticle,
            fkuidlist: this.props.fkuidlist,
            modalOpenDelete: false
        }

        this.handleSubmitDeleteListArticle = this.handleSubmitDeleteListArticle.bind(this);

        this.handleCloseDelete = this.handleCloseDelete.bind(this)
        this.handleOpenDelete = this.handleOpenDelete.bind(this)
    }

    handleSubmitDeleteListArticle(event) {
        event.preventDefault();
        var self = this;
        var listArticleData = {
            fkuiduser: this.props.app.id,
            id : this.props.fkuidarticle
        }
        API.deleteArticleList(this.props.app.token, listArticleData).then((res) => {
            var response = res.data;
            self.setState({
                response: response,
            });
            self.handleCloseDeleteSecond();
        }, (rej) => {
            self.setState({
                error: rej.error,
            });
        });
    }

    handleCloseDeleteSecond() {
        var self = this;
        var listArticleData = {
            fkuidlist: this.state.fkuidlist
        }
        API.getArticleList(this.props.app.token, listArticleData).then((res) => {
            var response = res.data;
            self.props.addArticle(response.articles);
            this.handleCloseDelete();
        });
    }

    handleCloseDelete() {
        this.setState({
            modalOpenDelete: false,
        })
    }

    handleOpenDelete() {
        this.setState({
            modalOpenDelete: true,
        })
    }

    componentWillMount() {
    }

    render() {
        const { t } = this.props
        return (
            <Modal open={this.state.modalOpenDelete}
                onClose={this.handleCloseDelete} size='tiny' trigger={
                    <Image onClick={this.handleOpenDelete} size='small' src={supprimer} className="deleteImage"/>
                } >
                <Modal.Header id="modalHeader">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Image
                                    id="modalExit"
                                    src={Exit}
                                    onClick={this.handleCloseDelete}
                                    floated='right' />
                                <Header
                                    as="h2"
                                    id="modalTitle"
                                    textAlign='center'>
                                    Supprimer article
                                </Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column id="modalContentText">
                                {t("title1")}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column width={8}>
                                <Button
                                    id="cancelBtn"
                                    fluid
                                    size='massive'
                                    onClick={this.handleCloseDelete}>
                                    Annuler
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Button
                                    id="validBtn"
                                    size='massive'
                                    fluid
                                    onClick={this.handleSubmitDeleteListArticle}>
                                    Valider
                                </Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>

            </Modal>
        )
    }
}

const DeleteListArticle = connect(mapStateToProps, mapActionToProps)(ConnectedDeleteListArticle);
export default translate("DeleteListArticle")(DeleteListArticle);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/DeleteListArticle.js